import { render } from "./adminnav.vue?vue&type=template&id=119cb2cd"
import script from "./adminnav.vue?vue&type=script&lang=js"
export * from "./adminnav.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__